import { render, staticRenderFns } from "./TextInputAnswer.vue?vue&type=template&id=f95f93f0&"
import script from "./TextInputAnswer.vue?vue&type=script&lang=js&"
export * from "./TextInputAnswer.vue?vue&type=script&lang=js&"
import style0 from "./TextInputAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports